<template>
  <form-wizard ref="edit_vehicles_form" color="#39C0ED" @on-complete="editVehicle">
    <h2 slot="title"></h2>

    <tab-content
      title="Registration"
      :before-change="() => validateStep('childVehicleComponent')"
    >
      <vehicle-card
          :vehicle.sync="vehicle"
        ref="childVehicleComponent"
      />
    </tab-content>
    <tab-content title="Document" :before-change="() => validateStep('childDocumentComponent')">
      <document-card
         :vehicle="vehicle"
        ref="childDocumentComponent"
      />
    </tab-content>
    <tab-content title="Accesories info" :before-change="() => validateStep('childAccesoriesComponent')">
      <accesories-card
         :vehicle="vehicle"
        ref="childAccesoriesComponent"
      />
    </tab-content>
    
  </form-wizard>
</template>


<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// import komponen
import VehicleCard from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/VehicleCard.vue";
import DocumentCard from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/DocumentCard.vue";
import AccesoriesCard from "@/pages/Dashboard/Workshop/Vehicle/ComponentForm/AccesoriesCard.vue";
import Swal from "sweetalert2";


export default {
  name: "edit-bizdev-vehicles",

  props: {
    data_id: null,
    },


  components: {
    // ValidationError,
    FormWizard,
    TabContent,
    "vehicle-card": VehicleCard,
    "document-card": DocumentCard,
    "accesories-card": AccesoriesCard,
      
  },

  mixins: [formMixin],

  data: () => ({
      vehicle:[],
    
  }),

  created() {
    this.getBizdevVehicleData();
  },

  methods: {
    //fungsi dipanggile saat page pertamakali dibuka
    async getBizdevVehicleData(){
      //check id ikut terkirim di route
      if(this.data_id.id){

        //ambil data di server sesuai dengan data id yang ada di route
        await this.$store.dispatch("workshop_vehicle/get", this.data_id.id)
        this.vehicle = await await this.$store.getters["workshop_vehicle/vehicle"]

         //butuh jeda time sebelum mengupdate value di chield client
        var self = this;
        setTimeout(function(){
          self.$refs.childVehicleComponent.getDataParent()
          self.$refs.childDocumentComponent.getDataParent()
          self.$refs.childAccesoriesComponent.getDataParent()

        }, 1);
           
           
          

      }
      else{
        //jika tidak ada kembali ke list
        this.$parent.$parent.modalCloseEdit();
      }
    },

    resetFile(ref) {
      this.$refs[ref].clearField()
    },

    
       sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    // fungsi edit data
    async editVehicle() {
       this.$refs.childVehicleComponent.getData()
      this.$refs.childDocumentComponent.getData()
      this.$refs.childAccesoriesComponent.getData()

      //set var data yang akan dikirm ke server
      const data = {
        type: "workshop_vehicles",
        id:this.vehicle.id,
        vehicle_door_no : this.vehicle.vehicle_door_no,
        vehicle_pool: this.vehicle.vehicle_pool,
        vehicle_business_unit_id: this.vehicle.vehicle_business_unit_id,
        vehicle_body_color: this.vehicle.vehicle_body_color,
        vehicle_plate_color: this.vehicle.vehicle_plate_color,
        vehicle_registration_year: this.vehicle.vehicle_registration_year,
        vehicle_registration_name:this.vehicle.vehicle_registration_name,
        vehicle_type_id: this.vehicle.vehicle_type,
        vehicle_plate_no: this.vehicle.vehicle_plate_no,
        vehicle_production_year: this.vehicle.vehicle_production_year,
        vehicle_chassis_no: this.vehicle.vehicle_chassis_no,
        vehicle_engine_no: this.vehicle.vehicle_engine_no,
        vehicle_document: this.vehicle.document,
        vehicle_accessory: this.vehicle.accesories,
      }
      
      console.log(data)
      try {
          //kirim data ke server
        await this.$store.dispatch("workshop_vehicle/update", data);
             //panggil alert succes
        await this.$store.dispatch(
        "alerts/success",
        "Successfully registered."
        );
        //kembali ke list
        // await this.$router.replace({name: 'Detail Vehicle', params: { id: this.vehicle.id }});
        this.$parent.$parent.modalCloseEdit();

      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
        "alerts/error",
        "Oops, something went wrong"
        );
        this.setApiValidation(e.response.data.errors);
      }

    },
      
    //   //set data yang diambil dari child info
    // dataInfo (value) {
    //   console.log(value) 
    //   this.vehicle.info = value
      
    // },
    
    // //set data yang diambil dari child client
    // dataClient (value) {
    //   console.log(value) 
    //   this.vehicle.client = value
    // },
      
    //   //set data yang diambil dari child vehicle
    // dataVehicle (value) {
    //   this.vehicle = value
    // },
    
    // //set data yang diambil dari child service
    // dataService (value) {
    //   console.log(value) 
    //   console.log("bahahaha")
    //   this.vehicle.service = value
    // },
    
    // //set data yang diambil dari child part
    // dataPart (value) {
    //   // console.log(value) 
    //   this.vehicle.part = value
    // },
    
    //checke validasi stiap child sebulum pindah section
    validateStep(name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validateForm()
    },
  }
};
</script>
